import type { TCategoryListItem, TPromoCategoryListItem } from '~/shared/api/ke-gateway/categories';
import { PromoCategoryMM, CategoryMM  } from '~/entities/category';

function mapCategory(category: TCategoryListItem): CategoryMM {
  return new CategoryMM({
    id: category.id,
    title: category.title,
    icon: {
      link: category.iconLink,
    },
    childrens: category.children?.map(mapCategory) ?? [], 
    path: category.path,
  });
}

function mapPromoCategory(category: TPromoCategoryListItem): PromoCategoryMM {
  return new PromoCategoryMM({
    id: category.id,
    title: category.title,  
    icon: {
      link: category.iconLink,
    },
    deepLink: category.deepLink,
    subtitle: category.subtitle,
  });
}

export { mapCategory, mapPromoCategory };